import React, { useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTbodyPosition } from '../../../../../utils/hooks/useTbodyPosition';

import TableRows from './TableRows';

const TableBody = ({ isLoading, data }) => {
  const bodyRef = useRef(null);
  const position = useTbodyPosition({ bodyRef, count: data?.length, bodyHeight: '300px' });

  return (
    <tbody
      className={classNames('', { 'tbody-loading': isLoading })}
      style={{ backgroundPositionY: position.y, backgroundPositionX: position.x }}
      ref={bodyRef}
    >
      <TableRows data={data} isLoading={isLoading} />
    </tbody>
  );
};

TableBody.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.array,
}

export default TableBody;
